const toPath = (key: string): string[] => {
    if (key === null || key === undefined || !key.length) {
        return [];
    }
    if (typeof key !== "string") {
        throw new Error("toPath() expects a string");
    }
    return key.split(/[.[\]]+/).filter(Boolean);
};

const getIn = (state: object, complexKey: string): unknown => {
    const path = toPath(complexKey);
    let current: unknown = state;
    for (let i = 0; i < path.length; i++) {
        const key = path[i];
        if (
            current === undefined ||
            current === null ||
            typeof current !== "object" ||
            (Array.isArray(current) && Number.isNaN(Number(key)))
        ) {
            return undefined;
        }
        current = (current as Record<string, unknown>)[key];
    }
    return current;
};

export default getIn;
